import SkeletonBase from "newui/components/Skeleton";

interface PanelMeetingStepProps {
	rfxId: number;
	rfxSubmissionId?: number;
	isLoading?: boolean;
}

export const PanelMeetingStep: React.FC<PanelMeetingStepProps> = ({
	rfxId,
	rfxSubmissionId,
	isLoading = false,
}) => {
	if (isLoading) {
		return (
			<div className="space-y-3">
				<SkeletonBase startColor="lightgray" width="100%" height="48px" className="!rounded-lg" />
				<SkeletonBase startColor="lightgray" width="100%" height="48px" className="!rounded-lg" />
			</div>
		);
	}

	return (
		<div data-testid="panel-meeting-step">
			<p className="text-sm text-gray-500 mb-4">
				Facilitate the panel meeting for final scoring discussions and award decisions.
			</p>
			{/* TODO: Render panel meeting interface when API is available */}
			<div className="rounded-lg border border-dashed border-gray-300 p-8 text-center text-gray-400 text-sm">
				Panel meeting interface will appear here.
			</div>
		</div>
	);
};
